var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 202 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5308 48.2371L48.6108 10.1242C45.3009 5.06203 38.2898 4.07397 33.7098 8.02422L12.2214 26.558C6.31924 31.6486 4.29405 39.9216 7.17737 47.1628C31.8438 109.111 79.1003 159.389 139.402 187.843L152.197 193.881C160.581 197.837 170.572 195.759 176.682 188.787L194.337 168.646C198.322 164.1 197.394 157.086 192.364 153.733L156.937 130.115C153.204 127.627 148.395 127.428 144.469 129.601L123.461 141.231C123.099 141.431 122.651 141.388 122.334 141.122L107.299 128.501C90.7304 114.591 75.8543 98.7814 62.9774 81.3975L62.7251 81.057C62.501 80.7544 62.4658 80.3515 62.6343 80.0146L74.0479 57.1873C75.4795 54.3242 75.2825 50.9163 73.5308 48.2371Z",
    stroke: "#F7F7F7",
    strokeWidth: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e1043e673b3ce8992fc8493b99e703e4.svg";
export { ForwardRef as ReactComponent };